<div class="cart-for-empty">
    <div class="cart-for-empty__inner">
        <shared-cart-empty-block></shared-cart-empty-block>
        <shared-header *ngIf="isLocationDetailsPage$ | async" [brandAccent]="true" type="5" marginTop="sm"
            marginBottom="none">
            {{pickupTimeLabel$ | async}}
        </shared-header>
        <shared-header type="3" marginTop="none" marginBottom="md">{{emptyLabel}}</shared-header>
        <shared-btn (onClick)="handleViewMenuClick($event)">{{cartEmptyLabelBtn$ | async}}</shared-btn>
    </div>
</div>